import {keyCodes} from '@pb/kit-util-key-codes';

export const Digits = {
    THOUSAND: 'K',
    MILLION: 'M',
    BILLION: 'B',
    TRILLION: 'Tn',
    QUADRILLION: 'Qn',
    ONE: '',
} as const;
export type Digit = string;

/**
 * @deprecated It will be removed in 6 months 07-14-2026. Use string literal 'COMMA' directly instead.
 */
export const COMMA = 'COMMA' as const;

/**
 * @deprecated It will be removed in 6 months 07-14-2026. Use string literal 'PERIOD' directly instead.
 */
export const PERIOD = 'PERIOD' as const;

/**
 * @deprecated It will be removed in 6 months 07-14-2026. Use string literal 'SPACE' directly instead.
 */
export const SPACE = 'SPACE' as const;

/**
 * @deprecated It will be removed in 6 months 07-14-2026. Use string literal 'QUOTE' directly instead.
 */
export const QUOTE = 'QUOTE' as const;

/**
 * @deprecated It will be removed in 6 months 07-14-2026. Use plain `string` type instead.
 * Components should accept any string value and handle unknown values gracefully with fallbacks.
 * Example: Use `string` instead of `SeparatorType`.
 */
export type SeparatorType = 'COMMA' | 'PERIOD' | 'SPACE' | 'QUOTE' | string;

/**
 * @deprecated It will be removed in 6 months 07-14-2026. Use custom mapping objects with string keys instead.
 * Components should accept any string value and handle unknown values gracefully with fallbacks.
 * Example: Create your own mapper like `const SEPARATOR_MAP: Record<string, string> = { COMMA: ',', DOT: '.', ... }`.
 */
export const Separator = {
    [COMMA]: ',',
    [PERIOD]: '.',
    [SPACE]: String.fromCharCode(160), // nbsp
    [QUOTE]: "'",
} as const;

/**
 * @deprecated It will be removed in 6 months 07-14-2026. Use custom key code mappings instead.
 * Components should handle key codes directly without relying on centralized mappings.
 */
export const SeparatorCode = {
    [COMMA]: keyCodes.KEY_COMMA,
    [PERIOD]: keyCodes.KEY_PERIOD,
    [SPACE]: keyCodes.KEY_SPACE,
    [QUOTE]: keyCodes.KEY_QUOTE,
} as const;
export const MIN_ROUND_OFF_VALUE = 1000 as const;
export const MIN_MILLIONT_VALUE = 9445 as const;
